import { serverUrl } from "../../data/dataApi";

const Loading = ({ statusMessage }) => {
    return(
        <div className="message-wrapper loading-wrapper api-message tif-pt-35 tif-px-md-0 tif-px-15 tif-pb-45">
            <div className="message-container d-flex align-items-start tif-mx-auto">
                <img src={`${serverUrl}/static/assets/gelest-chatbot-widget-logo.svg`} className="message-user-img flex-shrink-0" alt="Gelest chatbot logo" />
                <div className="message flex-grow-1">
                    <div className="message-text d-flex justify-content-between">
                        <div className="response-load">
                            <div className="response-load-dot"></div>
                            <div className="response-load-dot"></div>
                            <div className="response-load-dot"></div>
                        </div>
                    </div>
                    {statusMessage && (
                        <div className="status-message shimmer-text fst-italic tif-font-sm tif-mt-10">
                            {statusMessage}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Loading;